import { DestroyRef, Directive, inject, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { AuthorizationService } from './authorization.service';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Directive({
  selector: '[appIsBlv]'
})
export class IsBlvDirective implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly templateRef = inject(TemplateRef<any>);
  private readonly authorizationService = inject(AuthorizationService);

  private isVisible = false;

  ngOnInit() {
    this.authorizationService.authorities$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((authorities) => {

      // If he doesn't have any roles, we clear the viewContainerRef
      if (authorities.length === 0) {
        this.viewContainerRef.clear();
      }

      // If the user has the role needed to
      // render this component we can add it
      const isBlv = this.authorizationService.isBlv()
      if (isBlv) {
        // If it is already visible (which can happen if
        // his roles changed) we do not need to add it a second time
        if (!this.isVisible) {
          // We update the `isVisible` property and add the
          // templateRef to the view using the
          // 'createEmbeddedView' method of the viewContainerRef
          this.isVisible = true;
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
      } else {
        // If the user does not have the role,
        // we update the `isVisible` property and clear
        // the contents of the viewContainerRef
        this.isVisible = false;
        this.viewContainerRef.clear();
      }
    });
  }
}
